import styled from 'styled-components';

import { Button } from 'components/Button';

export const BaseInfoText = styled.p`
  color: ${({ theme }) => theme.palette.text.secondary};
  font-size: 16px;
  font-weight: 400;
`;

export const UploadContainer = styled.div<{ $dragActive: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background: ${({ $dragActive, theme }) => ($dragActive ? theme.palette.primary.light : '')};
  padding: 30px 0px;
  border-radius: 8px;
  border: ${({ $dragActive, theme }) =>
    $dragActive ? `2px dashed ${theme.palette.primary.main}` : `2px dashed ${theme.palette.grey[400]}`};
  margin-top: 16px;
`;

export const FileContainer = styled.div`
  margin-top: 16px;
  display: flex;
  padding: 16px;
  align-items:;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.grey[400]};
  background: ${({ theme }) => theme.palette.grey[50]};
  z-index: 10;
  flex-direction: column;
  width: 100%;
`;

export const FileName = styled.p`
  color: ${({ theme }) => theme.palette.grey[900]};
  font-size: 16px;
  font-weight: 400;
  margin: 0;
`;

export const RemoveButton = styled(Button)`
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.grey[400]};
  background: ${({ theme }) => theme.palette.common.white};
  max-width: 32px;
  min-width: 32px;
  max-height: 32px;
  min-height: 32px;
`;

export const InfoMessage = styled.p`
  color: ${({ theme }) => theme.palette.grey[900]};
  text-align: center;
  font-size: 16px;
  margin: 0;
  margin-top: 16px;
`;

export const SecondaryMessage = styled.p`
  color: ${({ theme }) => theme.palette.grey[600]};
  text-align: center;
  font-size: 14px;
  margin: 0;
  margin-top: 4px;
`;
